import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Divider, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  width: '795px',
  borderRadius: 2,
  boxShadow: 24,
};

const ResendModal = ({ appContext, openModal, setAppContext, setOpenModal }) => {
  const handleClose = () => {
    setOpenModal(false);
    setAppContext({});
  };
  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box sx={{ px: 4, py: 1 }}>
          <IconButton
            onClick={handleClose}
            size="small"
            sx={{
              position: 'absolute',
              top: 2,
              right: 2,
            }}
            aria-label="close"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
          <Typography id="modal-modal-title" variant="body1" sx={{ fontWeight: '600' }}>
            Approval Notification(s) Sent
          </Typography>
        </Box>
        <Divider />
        <Box sx={{ px: 4 }}>
          <Typography id="modal-modal-description" variant="body2" sx={{ mt: 2 }}>
            An approval notification has been sent for the Training Request made by{' '}
            {appContext?.fullName}
          </Typography>
        </Box>
        <Box sx={{ px: 4, pb: 2 }}>
          <Button variant="contained" onClick={handleClose} sx={{ mt: 2 }}>
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ResendModal;
